import type { Contact, MeetingMinute, Project, Task } from '../types/crm';

export const SIDEBAR_LIST_PREVIEW = 2;

export function newestContacts(contacts: Contact[]): Contact[] {
  return [...contacts].sort((a, b) => (b.created_at ?? '').localeCompare(a.created_at ?? ''));
}

export function newestProjects(projects: Project[]): Project[] {
  return [...projects].sort((a, b) => (b.created_at ?? '').localeCompare(a.created_at ?? ''));
}

export function newestMeetingMinutes(minutes: MeetingMinute[]): MeetingMinute[] {
  return [...minutes].sort((a, b) => {
    const da = a.meeting_date ?? a.created_at ?? '';
    const db = b.meeting_date ?? b.created_at ?? '';
    return db.localeCompare(da);
  });
}

export function activeTasks(tasks: Task[]): Task[] {
  return tasks
    .filter((t) => t.status !== 'Done')
    .sort((a, b) => (b.created_at ?? b.due_date ?? '').localeCompare(a.created_at ?? a.due_date ?? ''));
}

export function doneTasks(tasks: Task[]): Task[] {
  return tasks
    .filter((t) => t.status === 'Done')
    .sort((a, b) => (b.due_date ?? b.created_at ?? '').localeCompare(a.due_date ?? a.created_at ?? ''));
}

export function takePreview<T>(items: T[], limit = SIDEBAR_LIST_PREVIEW): T[] {
  return items.slice(0, limit);
}
